(function () {
  /* ==========================================================================
     CONFIGURATION
  ========================================================================== */
  console.log("========= Run the Discount Code =========");
  const TARGET_SELECTOR  = '.cart__footer';
  const WRAPPER_SELECTOR = '[data-cart-discount-wrapper]';
  const STORAGE_KEY      = 'ck_active_discount_code';
  const CHECKOUT_FLAG_KEY = 'ck_checkout_with_code';

  /* ==========================================================================
     DOUBLE-INIT GUARD  (Intelligems may re-inject the script)
  ========================================================================== */
  if (typeof window !== 'undefined') {
    if (window.__tbsDiscountScriptInitialized) return;
    window.__tbsDiscountScriptInitialized = true;
  }

  /* ==========================================================================
     PERSISTENCE  (localStorage + sessionStorage for maximum survival)
  ========================================================================== */
  function persistCode(code) {
    if (!code) return;
    try {
      localStorage.setItem(STORAGE_KEY, code.toUpperCase());
      sessionStorage.setItem(STORAGE_KEY, code.toUpperCase());
    } catch (e) {}
  }
  function getPersistedCode() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) { return null; }
  }
  function clearPersistedCode() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }
  function setCheckoutFlag(code) {
    try {
      sessionStorage.setItem(CHECKOUT_FLAG_KEY, code.toUpperCase());
    } catch(e){}
  }
  
  function getCheckoutFlag() {
    try {
      return sessionStorage.getItem(CHECKOUT_FLAG_KEY);
    } catch(e){ return null; }
  }
  
  function clearCheckoutFlag() {
    try {
      sessionStorage.removeItem(CHECKOUT_FLAG_KEY);
    } catch(e){}
  }
  /* ==========================================================================
     FLAGS
  ========================================================================== */
  let isRemovingInvalidCodes = false;
  let _reapplyInProgress     = false;

  /* ==========================================================================
     UTILITIES
  ========================================================================== */
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(cents / 100).replace(/\.00\b/, '');
  }

  function isShippingPage() {
    try {
      if (document.body && document.body.classList.contains('template-page-shipping')) return true;
    } catch (e) {}
    const path = (window.location && window.location.pathname) || '';
    return path.indexOf('/pages/shipping') >= 0;
  }

  /** Refresh cart drawer via sections API + renderContents (same as cart-drawer.js) */
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble&_=' + Date.now());
      const sections = await res.json();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ sections }, { openDrawer: false });
      }
    } catch (e) {}
  }

  /** Refresh shipping page section only (no full reload, no cart:updated to avoid multi-ship blink) */
  async function refreshShippingPageSection() {
    const sp = document.querySelector('shipping-page');
    if (sp && typeof sp.refreshSectionFromServer === 'function') {
      sp._lastRefreshTime = Date.now();
      await sp.refreshSectionFromServer();
    } else {
      window.location.reload();
    }
  }

  async function fetchCart() {
    const res = await fetch('/cart.js?' + Date.now());
    return res.json();
  }

  function getApplicableDiscountCode(cart) {
    if (!cart?.discount_codes?.length) return null;
    const dc = cart.discount_codes.find(d => d.applicable === true);
    return dc ? dc.code : null;
  }

  /* ==========================================================================
     SESSION HELPERS
  ========================================================================== */
  async function clearDiscountFromSession() {
    try {
      await fetch('/checkout?discount=', { method: 'GET', credentials: 'same-origin', redirect: 'manual' });
      await sleep(100);
    } catch (e) {}
  }

  async function applyCodeToSession(code, retries = 4) {
    for (let i = 0; i < retries; i++) {
      try {
        await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET', credentials: 'same-origin', redirect: 'manual' });
        await sleep(120 + i * 80);
        const cart    = await fetchCart();
        const applied = getApplicableDiscountCode(cart);
        if (applied && applied.toLowerCase() === code.toLowerCase()) return { success: true, cart };
      } catch (e) {}
    }
    return { success: false, cart: await fetchCart() };
  }

  /* ==========================================================================
     SVG CONSTANTS
  ========================================================================== */
  const BADGE_SVG_OPEN  = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false" role="presentation">';
  const BADGE_SVG_PATHS = '<path d="M9.39937 0H6.82937C6.49325 0.000121142 6.16061 0.0680187 5.85134 0.199633C5.54206 0.331247 5.2625 0.523875 5.02937 0.766L0.419371 5.552C0.146884 5.83505 -0.00367186 6.21371 6.80452e-05 6.60659C0.00380795 6.99946 0.161545 7.37519 0.439371 7.653L3.91937 11.133C4.15093 11.3642 4.46391 11.4954 4.7911 11.4983C5.1183 11.5013 5.43362 11.3759 5.66937 11.149L10.7854 6.223C10.9792 6.0364 11.1334 5.81259 11.2388 5.56499C11.3441 5.31739 11.3984 5.05108 11.3984 4.782V2C11.3984 1.46957 11.1877 0.960859 10.8126 0.585786C10.4375 0.210714 9.9288 0 9.39837 0" fill="white"/><path d="M6.82937 0V-1L6.82901 -1L6.82937 0ZM5.02937 0.766L5.7496 1.45974L5.74973 1.4596L5.02937 0.766ZM0.419371 5.552L-0.300854 4.85826L-0.301048 4.85846L0.419371 5.552ZM0.439371 7.653L1.14648 6.94589L1.14646 6.94587L0.439371 7.653ZM3.91937 11.133L3.21226 11.8401L3.21284 11.8407L3.91937 11.133ZM5.66937 11.149L6.36284 11.8695L6.36298 11.8694L5.66937 11.149ZM10.7854 6.223L10.0919 5.50254L10.0918 5.50264L10.7854 6.223ZM11.3984 4.782H10.3984V4.78204L11.3984 4.782ZM9.39937 0V-1H6.82937V0V1H9.39937V0ZM6.82937 0L6.82901 -1C6.35845 -0.99983 5.89275 -0.904774 5.45976 -0.720514L5.85134 0.199633L6.24291 1.11978C6.42848 1.04081 6.62806 1.00007 6.82973 1L6.82937 0ZM5.85134 0.199633L5.45976 -0.720514C5.02678 -0.536254 4.63539 -0.266575 4.30901 0.0724001L5.02937 0.766L5.74973 1.4596C5.88961 1.31433 6.05735 1.19875 6.24291 1.11978L5.85134 0.199633ZM5.02937 0.766L4.30915 0.07226L-0.300854 4.85826L0.419371 5.552L1.1396 6.24574L5.7496 1.45974L5.02937 0.766ZM0.419371 5.552L-0.301048 4.85846C-0.755194 5.33021 -1.00612 5.96131 -0.999887 6.61611L6.80452e-05 6.60659L1.00002 6.59707C0.998776 6.46611 1.04896 6.33989 1.13979 6.24554L0.419371 5.552ZM6.80452e-05 6.60659L-0.999887 6.61611C-0.993653 7.2709 -0.730759 7.89711 -0.267715 8.36013L0.439371 7.653L1.14646 6.94587C1.05385 6.85327 1.00127 6.72803 1.00002 6.59707L6.80452e-05 6.60659ZM0.439371 7.653L-0.267736 8.36011L3.21226 11.8401L3.91937 11.133L4.62648 10.4259L1.14648 6.94589L0.439371 7.653ZM3.91937 11.133L3.21284 11.8407C3.62965 12.2568 4.19301 12.4929 4.78196 12.4983L4.7911 11.4983L4.80025 10.4984C4.73481 10.4978 4.67221 10.4716 4.6259 10.4253L3.91937 11.133ZM4.7911 11.4983L4.78196 12.4983C5.37091 12.5037 5.93849 12.2779 6.36284 11.8695L5.66937 11.149L4.9759 10.4285C4.92875 10.4739 4.86569 10.499 4.80025 10.4984L4.7911 11.4983ZM5.66937 11.149L6.36298 11.8694L11.479 6.94336L10.7854 6.223L10.0918 5.50264L4.97577 10.4286L5.66937 11.149ZM10.7854 6.223L11.4789 6.94346C11.7697 6.66355 12.001 6.32785 12.159 5.95644L11.2388 5.56499L10.3186 5.17354C10.2659 5.29734 10.1888 5.40924 10.0919 5.50254L10.7854 6.223ZM11.2388 5.56499L12.159 5.95644C12.317 5.58504 12.3984 5.18557 12.3984 4.78196L11.3984 4.782L10.3984 4.78204C10.3984 4.91658 10.3712 5.04974 10.3186 5.17354L11.2388 5.56499ZM11.3984 4.782H12.3984V2H11.3984H10.3984V4.782H11.3984ZM11.3984 2H12.3984C12.3984 1.20435 12.0823 0.441289 11.5197 -0.12132L10.8126 0.585786L10.1055 1.29289C10.293 1.48043 10.3984 1.73478 10.3984 2H11.3984ZM10.8126 0.585786L11.5197 -0.12132C10.9571 -0.68393 10.194 -1 9.39837 -1V0V1C9.66359 1 9.91794 1.10536 10.1055 1.29289L10.8126 0.585786Z" fill="#122145"';

  function makeBadgeSVG(maskId) {
    return BADGE_SVG_OPEN +
      `<mask id="${maskId}" fill="white"><path d="M9.39937 0H6.82937C6.49325 0.000121142 6.16061 0.0680187 5.85134 0.199633C5.54206 0.331247 5.2625 0.523875 5.02937 0.766L0.419371 5.552C0.146884 5.83505 -0.00367186 6.21371 6.80452e-05 6.60659C0.00380795 6.99946 0.161545 7.37519 0.439371 7.653L3.91937 11.133C4.15093 11.3642 4.46391 11.4954 4.7911 11.4983C5.1183 11.5013 5.43362 11.3759 5.66937 11.149L10.7854 6.223C10.9792 6.0364 11.1334 5.81259 11.2388 5.56499C11.3441 5.31739 11.3984 5.05108 11.3984 4.782V2C11.3984 1.46957 11.1877 0.960859 10.8126 0.585786C10.4375 0.210714 9.9288 0 9.39837 0"/></mask>` +
      BADGE_SVG_PATHS + ` mask="url(#${maskId})"/></svg>`;
  }

  /* ==========================================================================
     INSERT DISCOUNT UI  (once only)
  ========================================================================== */
  function insertDiscountUI() {
    const target = document.querySelector(TARGET_SELECTOR);
    if (!target || target.querySelector(WRAPPER_SELECTOR)) return;

    const uid = 'injected-' + Date.now();
    target.insertAdjacentHTML('afterbegin', `
      <div class="cart__discount" data-cart-discount-wrapper>
        <div class="cart__discount__input-wrapper">
          <input type="text" name="discount" id="cart-discount-code"
            class="cart__discount__input" placeholder="Discount code"
            autocomplete="off" data-discount-input />
          <button type="button" class="cart__discount__apply-btn" data-discount-apply>Apply</button>
        </div>
        <div class="cart__discount__error" data-discount-error
          data-error-invalid="Invalid discount code"
          data-error-expired="This discount code is invalid or expired"
          data-error-not-applicable="This discount code doesn't apply to your cart"
          hidden>
          <span data-discount-error-message>Invalid discount code</span>
        </div>
        <div class="cart__discount__applied" data-discount-applied hidden>
          <div class="cart__discount__applied-content">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g clip-path="url(#clip-tag-${uid})">
                <mask id="mask-tag-${uid}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                  <path d="M0 0H14V14H0V0Z" fill="white"/>
                </mask>
                <g mask="url(#mask-tag-${uid})">
                  <mask id="path-tag-${uid}" fill="white">
                    <path d="M10.5 1.5H7.92999C7.59387 1.50012 7.26123 1.56802 6.95195 1.69963C6.64268 1.83125 6.36312 2.02388 6.12999 2.266L1.51999 7.052C1.2475 7.33505 1.09694 7.71371 1.10068 8.10659C1.10442 8.49946 1.26216 8.87519 1.53999 9.153L5.01999 12.633C5.25155 12.8642 5.56453 12.9954 5.89172 12.9983C6.21892 13.0013 6.53424 12.8759 6.76999 12.649L11.886 7.723C12.0798 7.5364 12.2341 7.31259 12.3394 7.06499C12.4447 6.81739 12.499 6.55108 12.499 6.282V3.5C12.499 2.96957 12.2883 2.46086 11.9132 2.08579C11.5381 1.71071 11.0294 1.5 10.499 1.5"/>
                  </mask>
                  <path d="M10.5 1.5H7.92999C7.59387 1.50012 7.26123 1.56802 6.95195 1.69963C6.64268 1.83125 6.36312 2.02388 6.12999 2.266L1.51999 7.052C1.2475 7.33505 1.09694 7.71371 1.10068 8.10659C1.10442 8.49946 1.26216 8.87519 1.53999 9.153L5.01999 12.633C5.25155 12.8642 5.56453 12.9954 5.89172 12.9983C6.21892 13.0013 6.53424 12.8759 6.76999 12.649L11.886 7.723C12.0798 7.5364 12.2341 7.31259 12.3394 7.06499C12.4447 6.81739 12.499 6.55108 12.499 6.282V3.5C12.499 2.96957 12.2883 2.46086 11.9132 2.08579C11.5381 1.71071 11.0294 1.5 10.499 1.5" fill="white"/>
                  <path d="M7.92999 1.5V0.5L7.92963 0.5L7.92999 1.5ZM6.12999 2.266L6.85021 2.95974L6.85035 2.9596L6.12999 2.266ZM1.51999 7.052L0.799762 6.35826L0.799569 6.35846L1.51999 7.052ZM1.53999 9.153L2.24709 8.44589L2.24707 8.44587L1.53999 9.153ZM5.01999 12.633L4.31288 13.3401L4.31346 13.3407L5.01999 12.633ZM6.76999 12.649L7.46346 13.3695L7.46359 13.3694L6.76999 12.649ZM11.886 7.723L11.1925 7.00254L11.1924 7.00264L11.886 7.723ZM12.499 6.282H11.499V6.28204L12.499 6.282ZM10.5 1.5V0.5H7.92999V1.5V2.5H10.5V1.5ZM7.92999 1.5L7.92963 0.5C7.45906 0.50017 6.99337 0.595226 6.56038 0.779486L6.95195 1.69963L7.34353 2.61978C7.52909 2.54081 7.72868 2.50007 7.93035 2.5L7.92999 1.5ZM6.95195 1.69963L6.56038 0.779486C6.12739 0.963746 5.73601 1.23343 5.40963 1.5724L6.12999 2.266L6.85035 2.9596C6.99023 2.81433 7.15796 2.69875 7.34353 2.61978L6.95195 1.69963ZM6.12999 2.266L5.40976 1.57226L0.799762 6.35826L1.51999 7.052L2.24021 7.74574L6.85021 2.95974L6.12999 2.266ZM1.51999 7.052L0.799569 6.35846C0.345423 6.83021 0.0944966 7.46131 0.10073 8.11611L1.10068 8.10659L2.10064 8.09707C2.09939 7.96611 2.14958 7.83989 2.24041 7.74554L1.51999 7.052ZM1.10068 8.10659L0.10073 8.11611C0.106963 8.7709 0.369857 9.39711 0.832902 9.86013L1.53999 9.153L2.24707 8.44587C2.15446 8.35327 2.10189 8.22803 2.10064 8.09707L1.10068 8.10659ZM1.53999 9.153L0.832881 9.86011L4.31288 13.3401L5.01999 12.633L5.72709 11.9259L2.24709 8.44589L1.53999 9.153ZM5.01999 12.633L4.31346 13.3407C4.73027 13.7568 5.29363 13.9929 5.88258 13.9983L5.89172 12.9983L5.90086 11.9984C5.83542 11.9978 5.77283 11.9716 5.72652 11.9253L5.01999 12.633ZM5.89172 12.9983L5.88258 13.9983C6.47153 14.0037 7.03911 13.7779 7.46346 13.3695L6.76999 12.649L6.07652 11.9285C6.02937 11.9739 5.9663 11.999 5.90086 11.9984L5.89172 12.9983ZM6.76999 12.649L7.46359 13.3694L12.5796 8.44336L11.886 7.723L11.1924 7.00264L6.07638 11.9286L6.76999 12.649ZM11.886 7.723L12.5795 8.44346C12.8703 8.16355 13.1016 7.82785 13.2596 7.45644L12.3394 7.06499L11.4192 6.67354C11.3665 6.79734 11.2894 6.90924 11.1925 7.00254L11.886 7.723ZM12.3394 7.06499L13.2596 7.45644C13.4176 7.08504 13.499 6.68557 13.499 6.28196L12.499 6.282L11.499 6.28204C11.499 6.41658 11.4719 6.54974 11.4192 6.67354L12.3394 7.06499ZM12.499 6.282H13.499V3.5H12.499H11.499V6.282H12.499ZM12.499 3.5H13.499C13.499 2.70435 13.1829 1.94129 12.6203 1.37868L11.9132 2.08579L11.2061 2.79289C11.3936 2.98043 11.499 3.23478 11.499 3.5H12.499ZM11.9132 2.08579L12.6203 1.37868C12.0577 0.81607 11.2946 0.5 10.499 0.5V1.5V2.5C10.7642 2.5 11.0186 2.60536 11.2061 2.79289L11.9132 2.08579Z" fill="white" mask="url(#path-tag-${uid})"/>
                  <path d="M9.49998 5.06301C9.81092 5.06301 10.063 4.81095 10.063 4.50001C10.063 4.18908 9.81092 3.93701 9.49998 3.93701C9.18904 3.93701 8.93698 4.18908 8.93698 4.50001C8.93698 4.81095 9.18904 5.06301 9.49998 5.06301Z" fill="#a21d35"/>
                  <path d="M9.48999 4.48999H9.50999V4.50999H9.48999V4.48999Z" fill="white"/>
                </g>
              </g>
              <defs>
                <clipPath id="clip-tag-${uid}"><rect width="14" height="14" fill="white"/></clipPath>
              </defs>
            </svg>
            <span class="cart__discount__code" data-discount-code-display></span>
          </div>
          <button type="button" class="cart__discount__remove" data-discount-remove aria-label="Remove discount code">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>`);
  }

  /* ==========================================================================
     LOADER HELPERS
  ========================================================================== */
  function showSubtotalLoader() {
    const el = document.querySelector('[data-subtotal-price]');
    if (!el) return;
    const ct = el.closest('.cart__total');
    if (ct) {
      ct.classList.add('is-loading');
      if (!el.classList.contains('cart__total__price--animated'))
        el.classList.add('cart__total__price--animated');
      if (!ct.querySelector('.cart__price__loader')) {
        const ldr = document.createElement('div');
        ldr.className = 'cart__price__loader loader';
        ldr.innerHTML = '<div class="loader-indeterminate"></div>';
        ct.appendChild(ldr);
      }
    }
  }
  function hideSubtotalLoader() {
    const el = document.querySelector('[data-subtotal-price]');
    if (!el) return;
    const ct = el.closest('.cart__total');
    if (ct) ct.classList.remove('is-loading');
  }

  /* ==========================================================================
     UI STATE HELPERS
  ========================================================================== */
  function showError(msg) {
    document.querySelectorAll('[data-discount-error]').forEach((div) => {
      const span = div.querySelector('[data-discount-error-message]');
      const input = div.closest('[data-cart-discount-wrapper]')?.querySelector('[data-discount-input]');
      if (span) span.textContent = msg;
      div.removeAttribute('hidden');
      if (input) {
        input.classList.add('has-error');
        if (window.innerWidth <= 749) input.classList.add('has-error-mobile');
        input.setAttribute('aria-invalid', 'true');
      }
      div.setAttribute('role', 'alert');
    });
  }
  function hideError() {
    document.querySelectorAll('[data-discount-error]').forEach((div) => {
      const span = div.querySelector('[data-discount-error-message]');
      const input = div.closest('[data-cart-discount-wrapper]')?.querySelector('[data-discount-input]');
      if (span) span.textContent = '';
      div.setAttribute('hidden', '');
      if (input) {
        input.classList.remove('has-error', 'has-error-mobile');
        input.removeAttribute('aria-invalid');
      }
      div.removeAttribute('role');
    });
  }
  function showApplied(code) {
    document.querySelectorAll('[data-discount-applied]').forEach((block) => {
      const display = block.querySelector('[data-discount-code-display]');
      const wrapper = block.closest('[data-cart-discount-wrapper]');
      const input = wrapper?.querySelector('[data-discount-input]');
      if (block && display) {
        block.removeAttribute('hidden');
        display.textContent = code.toUpperCase();
        if (input) input.value = '';
      }
    });
  }
  function hideApplied() {
    document.querySelectorAll('[data-discount-applied]').forEach((block) => {
      const display = block.querySelector('[data-discount-code-display]');
      block.setAttribute('hidden', '');
      if (display) display.textContent = '';
    });
  }
  function wipeLineBadges() {
    document.querySelectorAll('.cart__item__discount-line').forEach(el => el.remove());
  }

  /* ==========================================================================
     BADGE BUILDER  — creates one .cart__item__discount-line element
  ========================================================================== */
  function buildBadge(itemKey, allocIndex, label, amount) {
    const maskId = `discount-mask-${itemKey.replace(/[^a-zA-Z0-9]/g, '-')}-${allocIndex}-${Date.now()}`;
    const line   = document.createElement('p');
    line.className = 'cart__item__discount-line';

    const badge = document.createElement('span');
    badge.className = 'cart-item-discount-badge';
    badge.innerHTML = makeBadgeSVG(maskId);

    const title = document.createElement('span');
    title.className = 'cart-item-discount-title';
    title.textContent = `${label} (-${formatMoney(amount)})`;

    line.appendChild(badge);
    line.appendChild(title);
    return line;
  }

  function insertBadgeAfterTitle(container, badgeEl) {
    const titleEl = container.querySelector('.cart__item__title');
    if (titleEl && titleEl.parentNode) {
      titleEl.nextSibling
        ? titleEl.parentNode.insertBefore(badgeEl, titleEl.nextSibling)
        : titleEl.parentNode.appendChild(badgeEl);
    } else {
      container.insertBefore(badgeEl, container.firstChild);
    }
  }

  /* ==========================================================================
     UPDATE CART UI
     ─ The ONLY function that writes to the DOM.
     ─ Receives a (possibly pre-cleaned) cart object.
     ─ Determines discount type ONCE at the top:
         • ORDER-level  → cart_level_discount_applications present
                          → hide all line badges, update subtotal only
         • LINE-level   → allocations with type='discount_code' present
                          → show badges per line item
  ========================================================================== */
  function updateCartUI(cart) {
    hideSubtotalLoader();

    /* ── EMPTY CART ── */
    if (!cart.item_count) {
      if (getPersistedCode()) {
        clearPersistedCode();
        clearDiscountFromSession().catch(() => {});
      }
      wipeLineBadges();
      hideApplied();
      hideError();
      const el = document.querySelector('[data-discount-input]');
      if (el) el.value = '';
      const sub = document.querySelector('[data-subtotal-price]') || document.querySelector('[data-cart-price-holder]');
      if (sub) sub.innerHTML = formatMoney(0);
      document.querySelectorAll('[data-estimated-shipping]').forEach((shippingEl) => {
        const calculatedText = shippingEl.getAttribute('data-shipping-calculated-text') || 'Calculated at checkout';
        shippingEl.textContent = calculatedText;
      });
      document.querySelectorAll('[data-cart-discount-row]').forEach((row) => {
        row.style.display = 'none';
        row.setAttribute('hidden', '');
      });
      return;
    }

    /* ── SUBTOTAL ── */
    const sub = document.querySelector('[data-subtotal-price]') || document.querySelector('[data-cart-price-holder]');
    const subtotalAmount = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
    if (sub) sub.innerHTML = formatMoney(subtotalAmount);

    /* ── ESTIMATED SHIPPING ── */
    document.querySelectorAll('[data-estimated-shipping]').forEach((shippingEl) => {
      const freeText = shippingEl.getAttribute('data-shipping-free-text') || 'Free';
      const calculatedText = shippingEl.getAttribute('data-shipping-calculated-text') || 'Calculated at checkout';
      shippingEl.textContent = cart.requires_shipping ? calculatedText : freeText;
    });

    /* ── DISCOUNT ROW (before subtotal / estimated total) ── */
    const totalDiscount = cart.total_discount || 0;
    document.querySelectorAll('[data-cart-discount-row]').forEach((row) => {
      const amountEl = row.querySelector('[data-cart-discount-amount]');
      if (totalDiscount > 0 && amountEl) {
        row.style.display = '';
        row.removeAttribute('hidden');
        amountEl.textContent = '-' + formatMoney(totalDiscount);
      } else {
        row.style.display = 'none';
        row.setAttribute('hidden', '');
        if (amountEl) amountEl.textContent = '';
      }
    });

    /* ── INVALID CODE HANDLING ── */
    const invalidCodes = (cart.discount_codes || []).filter(dc => dc.applicable === false);
    if (invalidCodes.length > 0 && !isRemovingInvalidCodes) {
      isRemovingInvalidCodes = true;
      const input = document.querySelector('[data-discount-input]');
      if (input) {
        const v = input.value.trim().toLowerCase();
        if (invalidCodes.some(dc => dc.code.toLowerCase() === v)) input.value = '';
      }
      clearPersistedCode();
      wipeLineBadges();
      hideApplied();
      Promise.all(invalidCodes.map(dc =>
        fetch(`/discount/${dc.code}`, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } }).catch(() => {})
      )).then(() => {
        setTimeout(() => { isRemovingInvalidCodes = false; }, 2000);
        refreshCart(false);
      });
      return;
    }

    /* ── DISCOUNT TYPE DETECTION ──
       Order-level  = cart_level_discount_applications has entries
                      (Shopify applies these to the order total, not per-line)
       Line-level   = discount_allocations on items with type = 'discount_code'
    */
    const isOrderLevelDiscount =
      Array.isArray(cart.cart_level_discount_applications) &&
      cart.cart_level_discount_applications.length > 0;

    /* Build a Set of ONLY valid applicable code strings (lowercase) */
    const activeCodes = new Set(
      (cart.discount_codes || [])
        .filter(dc => dc.applicable === true)
        .map(dc => dc.code.toLowerCase())
    );

    /* ── PER-ITEM LOOP ── */
    cart.items.forEach(item => {
      /* Find the row DOM element — try multiple strategies */
      let row = document.querySelector(`[data-item="${item.key}"]`);
      if (!row) {
        const ctx = document.querySelector('cart-drawer, [data-cart-drawer], .drawer__items, [data-items-holder], .cart, [data-cart-items], cart-items');
        if (ctx) row = ctx.querySelector(`[data-item="${item.key}"]`);
      }
      if (!row) {
        document.querySelectorAll('[data-item]').forEach(el => {
          if (el.getAttribute('data-item') === item.key) row = el;
        });
      }
      if (!row) return;

      const originalLine = item.original_line_price;
      const finalLine    = item.line_price;
      const originalUnit = item.original_price;
      const finalUnit    = item.price;
      const hasDiscount  = originalUnit > finalUnit || originalLine > finalLine;

      /* Unit price */
      let priceEl = row.querySelector('.cart__item-price--sale') || row.querySelector('.cart__item-price--regular');
      if (!priceEl) {
        const pc = row.querySelector('.cart__item-prices');
        if (pc) priceEl = pc.querySelector('.cart__item-price--sale, .cart__item-price--regular');
      }
      if (priceEl) {
        priceEl.innerHTML = formatMoney(finalUnit);
        if (hasDiscount && priceEl.classList.contains('cart__item-price--regular')) {
          priceEl.classList.replace('cart__item-price--regular', 'cart__item-price--sale');
        }
      }

      /* Compare-at price */
      const compareEl = row.querySelector('.cart__item-price--compare');
      if (compareEl) {
        if (hasDiscount) {
          compareEl.innerHTML    = formatMoney(originalUnit);
          compareEl.style.display = 'inline-block';
        } else {
          compareEl.style.display = 'none';
        }
      }

      /* Line total */
      row.querySelectorAll('.cart__price').forEach(el => {
        let html = hasDiscount
          ? `<ins>${formatMoney(finalLine)}</ins><del>${formatMoney(originalLine)}</del>`
          : formatMoney(finalLine);
        const lp = el.querySelector('.line__price');
        if (lp) html += lp.outerHTML;
        el.innerHTML = html;
      });

      /* ── LINE-ITEM DISCOUNT BADGES ── */
      const inner = row.querySelector('.cart__item__content-inner');
      if (!inner) return;

      /* Preserve any title already rendered by Liquid before we wipe badges */
      let existingTitle = null;
      inner.querySelectorAll('.cart__item__discount-line').forEach(line => {
        const ts = line.querySelector('.cart-item-discount-title');
        if (ts) {
          const m = ts.textContent.trim().match(/^([^(]+)/);
          if (m) {
            const t = m[1].trim();
            if (t && t.toLowerCase() !== 'automatic discount') existingTitle = t;
          }
        }
      });

      /* Always wipe stale badges before re-rendering */
      inner.querySelectorAll('.cart__item__discount-line').forEach(l => l.remove());

      /*
        RULE:
        - ORDER-level discount  → NO badges on line items whatsoever
        - LINE-level discount   → Badge only for allocations where:
            1. discount_application.type === 'discount_code'  (not automatic/script)
            2. The code is in activeCodes (applicable === true)
            3. The code is NOT in invalidCodes
      */
      if (isOrderLevelDiscount) {
        /* Order discount: no per-line badges */
        return;
      }

      const hasAllocations = Array.isArray(item.discount_allocations) && item.discount_allocations.length > 0;

      if (hasAllocations) {
        item.discount_allocations.forEach((alloc, allocIndex) => {
          const app          = alloc.discount_application;
          const hasApp       = app != null;
          const hasCode      = hasApp && !!app.code;
          const discountType = hasApp ? app.type : null;

          /* Skip automatic / script / order-level allocations */
          const isAutomatic = !hasApp || !hasCode ||
                               discountType === 'automatic' ||
                               discountType === 'script';
          if (isAutomatic) return;

          const allocCode = app.code.toLowerCase();

          /* Skip if not in the active applicable set */
          if (!activeCodes.has(allocCode)) return;

          /* Skip if this code is in the invalid list */
          const isInvalid = invalidCodes.some(dc => dc.code.toLowerCase() === allocCode);
          if (isInvalid) return;

          /* Determine label:
             Priority 1 — existing Liquid-rendered title (what was already on page)
             Priority 2 — app.title from Shopify API
             Priority 3 — the code string itself (uppercase) */
          let label = existingTitle ||
                      (app.title && app.title.trim() && app.title.trim().toLowerCase() !== 'automatic discount'
                        ? app.title.trim()
                        : null) ||
                      app.code.toUpperCase();

          /* Final safety: if label equals the discount code, verify it's active */
          if (!activeCodes.has(label.toLowerCase()) && !activeCodes.has(allocCode)) return;

          const badgeEl = buildBadge(item.key, allocIndex, label, alloc.amount);
          insertBadgeAfterTitle(inner, badgeEl);
        });

      } else if (originalLine > finalLine) {
        /*
          Fallback: price difference but no allocations.
          Only show a badge if there is a valid applicable CODE-based discount
          (NOT automatic — those are shown in the totals area by Liquid).
        */
        const applicableCode = getApplicableDiscountCode(cart);
        if (applicableCode && activeCodes.has(applicableCode.toLowerCase())) {
          const badgeEl = buildBadge(item.key, 0, applicableCode.toUpperCase(), originalLine - finalLine);
          insertBadgeAfterTitle(inner, badgeEl);
        }
      }
    }); /* end cart.items.forEach */

    /* ── APPLIED BADGE (input area pill) ── */
    const applicable = getApplicableDiscountCode(cart);
    if (applicable && !isOrderLevelDiscount) {
      showApplied(applicable);
      persistCode(applicable);
    } else if (isOrderLevelDiscount) {
      /* Order-level discount is active but user didn't enter a code —
         keep the pill hidden; Liquid shows the total in the subtotal area */
      hideApplied();
    } else {
      hideApplied();
    }
  }

  /* ==========================================================================
     REFRESH CART
  ========================================================================== */
  async function refreshCart(forceRebuild = false) {
    try {
      showSubtotalLoader();
      if (forceRebuild) {
        const ci = document.querySelector('cart-items');
        if (ci && typeof ci.getCart === 'function') {
          ci.getCart();
          await sleep(500);
        }
      }
      const cart = await fetchCart();
      await sleep(forceRebuild ? 100 : 30);
      updateCartUI(cart);
      return cart;
    } catch (e) {
      hideSubtotalLoader();
      return null;
    }
  }

  /* ==========================================================================
     REAPPLY ON RETURN  (back button / tab focus / drawer open)
     ─ Uses a mutex to prevent concurrent calls flickering stale codes.
     ─ Before rendering, strips any discount_codes that don't match the
       live Shopify code — prevents numeric IDs leaking as labels.
  ========================================================================== */
  async function reapplyOnReturn() {
    if (_reapplyInProgress) return;
    _reapplyInProgress = true;
    try {
      const cart = await fetchCart();

      /* Empty cart — reset everything */
      if (!cart.item_count) {
        clearPersistedCode();
        wipeLineBadges();
        hideApplied();
        clearDiscountFromSession().catch(() => {});
        return;
      }

      const liveCode  = getApplicableDiscountCode(cart);
      const savedCode = getPersistedCode();

      if (liveCode) {
        clearCheckoutFlag();
        /* Shopify has a live code — clean the cart object before rendering
           to remove any OTHER stale codes (e.g. old order-level codes) */
        const cleanCart = Object.assign({}, cart, {
          discount_codes: (cart.discount_codes || []).filter(
            dc => dc.code.toLowerCase() === liveCode.toLowerCase()
          )
        });
        persistCode(liveCode);
        updateCartUI(cleanCart);
        showApplied(liveCode);

      } else if (savedCode) {
        const checkoutCode = getCheckoutFlag();

        /* ----------------------------------------------------------
           USER REMOVED DISCOUNT AT CHECKOUT
        ---------------------------------------------------------- */
        if (checkoutCode && checkoutCode.toLowerCase() === savedCode.toLowerCase()) {
          clearPersistedCode();
          clearCheckoutFlag();
      
          wipeLineBadges();
          hideApplied();
          updateCartUI(cart);
      
          return;
        }
        /* Session was reset (back-nav) — wipe stale DOM immediately, then re-apply */
        wipeLineBadges();
        hideApplied();
        const { success, cart: updatedCart } = await applyCodeToSession(savedCode, 3);
        if (success) {
          updateCartUI(updatedCart);
          showApplied(savedCode);
        } else {
          clearPersistedCode();
          updateCartUI(cart);
          hideApplied();
        }

      } else {
        /* No code anywhere — clean slate */
        wipeLineBadges();
        hideApplied();
        updateCartUI(cart);
      }
    } finally {
      _reapplyInProgress = false;
    }
  }

  function bindVisibilityReapply() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') reapplyOnReturn();
    });
    window.addEventListener('pageshow', e => { if (e.persisted) reapplyOnReturn(); });
    window.addEventListener('focus', () => reapplyOnReturn());
  }

  /* ==========================================================================
     CHECKOUT INTERCEPT
     ─ No saved code → let browser navigate normally (never adds ?discount=)
     ─ Has saved code → re-apply, then redirect with ?discount=CODE
  ========================================================================== */
  function interceptCheckout() {
    document.body.addEventListener('click', async function (e) {
      const btn = e.target.closest('[name="checkout"], .cart__checkout, a[href*="/checkout"]');
      if (!btn) return;

      const code = getPersistedCode();
      if (!code) {
        /* No code — ensure session is also clean, then let click proceed */
        clearDiscountFromSession().catch(() => {});
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      const orig = btn.textContent;
      btn.textContent = 'Loading…';
      btn.disabled = true;

      try {
        const { success } = await applyCodeToSession(code, 3);
        if (success) {
          setCheckoutFlag(code);
          window.location.href = `/checkout?discount=${encodeURIComponent(code.toUpperCase())}`;
        } else {
          clearPersistedCode();
          hideApplied();
          wipeLineBadges();
          window.location.href = '/checkout';
        }
      } catch (err) {
        window.location.href = `/checkout?discount=${encodeURIComponent(code.toUpperCase())}`;
      } finally {
        btn.textContent = orig;
        btn.disabled    = false;
      }
    }, true);
  }

  /* ==========================================================================
     APPLY DISCOUNT  (user action)
  ========================================================================== */
  async function applyDiscount(clickedBtn) {
    const wrapper = clickedBtn ? clickedBtn.closest('[data-cart-discount-wrapper]') : null;
    const input   = wrapper ? wrapper.querySelector('[data-discount-input]') : document.querySelector('[data-discount-input]');
    const applyBtn = clickedBtn || document.querySelector('[data-discount-apply]');
    const code     = (input && input.value.trim()) ? input.value.trim().toUpperCase() : '';

    if (!code) { showError('Enter a discount code'); return; }

    hideError();
    if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = 'Applying…'; }
    showSubtotalLoader();

    let previousCode = null;

    try {
      const currentCart  = await fetchCart();
      const existingCode = getApplicableDiscountCode(currentCart);

      if (existingCode && existingCode.toLowerCase() === code.toLowerCase()) {
        showApplied(existingCode);
        persistCode(existingCode);
        hideSubtotalLoader();
        if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Apply'; }
        return;
      }

      if (existingCode) {
        previousCode = existingCode;
        hideApplied();       /* clear old pill immediately — no stale flash */
        wipeLineBadges();    /* clear old line badges immediately */
        await clearDiscountFromSession();
      }

      const { success, cart } = await applyCodeToSession(code, 4);

      if (success) {
        persistCode(code);
        hideError();
        /* Update UI immediately for instant feedback, then refresh in background */
        updateCartUI(cart);
        showApplied(code);
        if (isShippingPage()) {
          await sleep(200);
          await Promise.all([refreshShippingPageSection(), refreshCartDrawer()]);
          updateCartUI(cart);
          showApplied(code);
          hideSubtotalLoader();
          return;
        }
        await refreshCartDrawer();
        updateCartUI(cart);
      } else {
        showError('This discount code has expired or is invalid');
        if (input) input.value = code;

        if (previousCode) {
          const { success: r, cart: rc } = await applyCodeToSession(previousCode, 3);
          if (r) {
            updateCartUI(rc);
            showApplied(previousCode);
            persistCode(previousCode);
          } else {
            clearPersistedCode();
            updateCartUI(await fetchCart());
            hideApplied();
          }
        } else {
          clearPersistedCode();
          updateCartUI(await fetchCart());
          hideApplied();
        }
      }
    } catch (err) {
      showError('Failed to apply discount. Please try again.');
      hideSubtotalLoader();
    } finally {
      if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = 'Apply'; }
    }
  }

  /* ==========================================================================
     REMOVE DISCOUNT  (user action)
  ========================================================================== */
  async function removeDiscount(clickedBtn) {
    const removeBtn = clickedBtn || document.querySelector('[data-discount-remove]');
    const wrapper   = removeBtn ? removeBtn.closest('[data-cart-discount-wrapper]') : null;
    const input    = wrapper ? wrapper.querySelector('[data-discount-input]') : document.querySelector('[data-discount-input]');

    hideError();
    if (removeBtn) removeBtn.disabled = true;
    showSubtotalLoader();

    /* Wipe everything immediately — before any async work */
    clearPersistedCode();
    hideApplied();
    wipeLineBadges();
    if (input) input.value = '';

    try {
      /* Double clear for Shopify session reliability */
      await clearDiscountFromSession();
      await sleep(80);
      await clearDiscountFromSession();

      if (isShippingPage()) {
        /* Brief wait for cart to reflect removal, then refresh both in parallel */
        let cart = await fetchCart();
        for (let i = 0; i < 4 && (cart?.total_discount > 0 || (cart?.discount_codes || []).some(dc => dc.applicable)); i++) {
          await sleep(150);
          cart = await fetchCart();
        }
        await sleep(150);
        await Promise.all([refreshShippingPageSection(), refreshCartDrawer()]);
        updateCartUI(cart);
        hideSubtotalLoader();
        if (removeBtn) removeBtn.disabled = false;
        return;
      }

      /* Brief wait for cart to reflect removal */
      let cart = await fetchCart();
      for (let i = 0; i < 4 && (cart?.total_discount > 0 || (cart?.discount_codes || []).some(dc => dc.applicable)); i++) {
        await sleep(150);
        cart = await fetchCart();
      }

      /* Update UI immediately for instant feedback, then refresh drawer */
      updateCartUI(cart);
      await refreshCartDrawer();
      updateCartUI(cart);

      if (cart?.discount_codes?.some(dc => dc.applicable === true)) {
        /* Extremely rare — still stuck: hard redirect */
        window.location.href = '/cart?discount=';
      } else {
        hideApplied();
        hideSubtotalLoader();
      }
    } catch (e) {
      hideSubtotalLoader();
      window.location.href = '/cart';
    } finally {
      if (removeBtn) removeBtn.disabled = false;
    }
  }

  /* ==========================================================================
     INIT DISCOUNT STATE  (on load / DOMContentLoaded)
  ========================================================================== */
  async function initDiscountState() {
    const savedCode = getPersistedCode();
    const cart      = await fetchCart();

    if (!cart.item_count) {
      if (savedCode) {
        clearPersistedCode();
        clearDiscountFromSession().catch(() => {});
      }
      hideApplied();
      return;
    }

    const liveCode = getApplicableDiscountCode(cart);

    if (liveCode) {
      clearCheckoutFlag();
      /* Strip any other stale codes before rendering */
      const cleanCart = Object.assign({}, cart, {
        discount_codes: (cart.discount_codes || []).filter(
          dc => dc.code.toLowerCase() === liveCode.toLowerCase()
        )
      });
      persistCode(liveCode);
      updateCartUI(cleanCart);
      showApplied(liveCode);

    } else if (savedCode) {
      const checkoutCode = getCheckoutFlag();

      if (checkoutCode && checkoutCode.toLowerCase() === savedCode.toLowerCase()) {
        clearPersistedCode();
        clearCheckoutFlag();
    
        updateCartUI(cart);
        hideApplied();
        return;
      }
      /* Re-apply lost session code */
      const { success, cart: uc } = await applyCodeToSession(savedCode, 3);
      if (success) {
        updateCartUI(uc);
        showApplied(savedCode);
      } else {
        clearPersistedCode();
        updateCartUI(cart);
        hideApplied();
      }

    } else {
      updateCartUI(cart);
    }
  }

  /* ==========================================================================
     WIRE UP  (event delegation so cart drawer + shipping page both work)
  ========================================================================== */
  function initDiscount() {
    insertDiscountUI();

    document.body.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('[data-discount-apply]');
      if (applyBtn) { e.preventDefault(); applyDiscount(applyBtn); return; }
      const removeBtn = e.target.closest('[data-discount-remove]');
      if (removeBtn) { e.preventDefault(); removeDiscount(removeBtn); return; }
    });

    document.body.addEventListener('keypress', (e) => {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('[data-discount-input]');
      if (input) {
        e.preventDefault();
        const applyBtn = input.closest('[data-cart-discount-wrapper]')?.querySelector('[data-discount-apply]');
        applyDiscount(applyBtn || null);
      }
    });

    document.body.addEventListener('input', (e) => {
      if (e.target.matches('[data-discount-input]')) hideError();
    });

    document.body.addEventListener('focus', (e) => {
      if (e.target.matches('[data-discount-input]') && window.innerWidth <= 749) {
        e.target.classList.remove('has-error-mobile');
      }
    }, true);

    initDiscountState();

    document.addEventListener('shipping-page:section-refreshed', () => {
      if (isShippingPage()) initDiscountState();
    });

    document.addEventListener('theme:cart-drawer:open', () => reapplyOnReturn());
    document.addEventListener('theme:cart:update', () => {
      if (!isShippingPage()) refreshCart(false);
    });
    document.addEventListener('theme:cart:change', () => {
      if (!isShippingPage()) refreshCart(false);
    });

    interceptCheckout();
    bindVisibilityReapply();
  }

  /* ==========================================================================
     BOOT
  ========================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscount);
  } else {
    initDiscount();
  }

})();